module.exports = __webpack_public_path__ + "static/assets/d070a0d0a2409bbc1ce23b5d992bc166.svg";